import { Loader } from '@anex/common';
import { Field, Form, withFormik } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AlertContainer, Error } from '../../../../components';
import { ContractInfo } from './components/ContractInfo';
import { SuccessInfo } from './components/SuccessInfo';
import { Disclaimer } from './components/Disclaimer';
var SelectPlanForm = observer(function (props) {
    var config = props.config, planStore = props.planStore, checkAddressStore = props.checkAddressStore, setFieldValue = props.setFieldValue, errors = props.errors, values = props.values, touched = props.touched;
    var _a = React.useState([]), planLengths = _a[0], setPlanLengths = _a[1];
    var _b = React.useState([]), plans = _b[0], setPlans = _b[1];
    React.useEffect(function () {
        processPlanDetails();
    }, []);
    React.useEffect(function () {
        props.summaryStore.getSummary(props.values.contractCode, '', props.checkAddressStore.nbnLocId, props.values.voipCode, null);
    }, [props.values.contractCode, props.values.voipCode]);
    React.useEffect(function () {
        if (checkAddressStore.qualificationResponse) {
            processPlanDetails();
        }
    }, [checkAddressStore.qualificationResponse]);
    React.useEffect(function () {
        if (checkAddressStore.sqAddressResponse) {
            checkAddressStore.loading = true;
            processPlanDetails();
            checkAddressStore.loading = false;
        }
    }, [checkAddressStore.upgardeSelected]);
    function processPlanDetails() {
        var planCode = planStore.planCode;
        var allPlans = planStore.getPlans();
        var lengths = Array.from(new Set(allPlans.map(function (p) { return p.length; })));
        setPlanLengths(lengths);
        if (checkAddressStore.upgardeSelected) {
            console.log('upgrade processing');
            var minimumDownloadSpeed = checkAddressStore.sqAddressResponse.sqSummary.nbn
                .alternativeTechnologyDetails.minimumDownloadSpeed;
            var minimumUploadSpeed = checkAddressStore.sqAddressResponse.sqSummary.nbn
                .alternativeTechnologyDetails.minimumUploadSpeed;
            if (minimumDownloadSpeed != null && minimumUploadSpeed != null) {
                var filterPlans = allPlans.filter(function (p) {
                    return p.baseSpeedInKb >= minimumDownloadSpeed * 1024 &&
                        p.baseSpeedOutKb >= minimumUploadSpeed * 1024;
                });
                console.log('filterPlans', filterPlans);
                setPlans(filterPlans);
            }
            else
                setPlans(allPlans);
        }
        else {
            var maxDownloadSpeed = checkAddressStore.maximumDownloadSpeed;
            var maxUploadSpeed = checkAddressStore.maximumUploadSpeed;
            if (maxDownloadSpeed != null && maxUploadSpeed != null) {
                var filterPlans = allPlans.filter(function (p) {
                    return p.baseSpeedInKb <= maxDownloadSpeed &&
                        p.baseSpeedOutKb <= maxUploadSpeed;
                });
                console.log('filterPlans', filterPlans);
                setPlans(filterPlans);
            }
            else if (maxDownloadSpeed != null && maxUploadSpeed == null) {
                var filterPlans = allPlans.filter(function (p) { return p.baseSpeedInKb <= maxDownloadSpeed; });
                setPlans(filterPlans);
            }
            else
                setPlans(allPlans);
        }
        if (planCode && !values['contractCode']) {
            var selectedPlan = allPlans.find(function (p) { return p.code === planCode; });
            if (selectedPlan) {
                var typePlan = selectedPlan.planType;
                setFieldValue('planType', typePlan);
                setFieldValue('contractCode', planCode);
                planStore.setPlanByType(typePlan, planCode);
            }
            else {
                var plans_1 = planStore.plans;
                var i = plans_1
                    ? plans_1.findIndex(function (j) { return j.code === planCode; })
                    : -1;
                setFieldValue('planType', i > -1 ? plans_1[i].planType : '');
            }
        }
        else if (!planCode) {
            var plans_2 = planStore.plans;
            var i = plans_2
                ? plans_2.findIndex(function (j) { return j.code === planCode; })
                : -1;
            setFieldValue('planType', i > -1 ? plans_2[i].planType : '');
        }
    }
    function renderPlans() {
        return planLengths.map(function (length) { return (React.createElement("optgroup", { key: "lngth-#{length}", label: length === 0
                ? 'Month to month, no lock in contract'
                : '24 Month Contract' }, plans
            .filter(function (plan) { return plan.length === length; })
            .sort(function (a, b) { return a.baseSpeedInKb - b.baseSpeedInKb; })
            .map(function (p, i) { return (React.createElement("option", { key: p.code, id: i.toString(), value: p.code, "data-plantype": p.planType ? p.planType : '' }, p.name)); }))); });
    }
    function onSelectPlan(e) {
        var planType = e.currentTarget[e.currentTarget.selectedIndex].getAttribute('data-plantype');
        setFieldValue('planType', planType);
        setFieldValue('contractCode', e.currentTarget.value);
    }
    function handleBooleanChange(e) {
        setFieldValue(e.target.name, e.target.checked);
        if (e.target.name === 'includeVoipBundle' && !e.target.checked) {
            setFieldValue('voipCode', '');
        }
    }
    function handleValueChange(e) {
        if (e.target.name === 'existingNumber') {
            setFieldValue('existingNumber', JSON.parse(e.target.value));
        }
        else {
            setFieldValue(e.target.name, e.target.value);
        }
    }
    var wholesalerName = '';
    if (config && config.wholesaleCustomerCode === 'CTL') {
        wholesalerName = 'Commtel';
    }
    return (React.createElement(Form, null,
        React.createElement(Loader, { loading: checkAddressStore.loading, text: "Please wait, processing your upgrade request.." }),
        React.createElement(SuccessInfo, null),
        React.createElement("hr", null),
        React.createElement(AlertContainer, null),
        planStore.plans !== null && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "w-100" },
                React.createElement("label", { htmlFor: "contractCode", className: "w-100" },
                    "Select a plan:",
                    React.createElement(Field, { id: "contractCode", name: "contractCode", component: "select", className: "form-control select-inline shadow-alt " + (errors.contractCode &&
                            'error'), value: values.contractCode, onChange: onSelectPlan },
                        React.createElement("option", { value: "" }, "Please select a plan"),
                        renderPlans()),
                    React.createElement(Error, { name: "contractCode" }),
                    React.createElement("br", null))),
            values.contractCode && (React.createElement("div", { className: "w-100" },
                React.createElement(ContractInfo, { plan: planStore.getContract(values.contractCode) }))))),
        React.createElement("br", null),
        React.createElement(Disclaimer, { wholesaler: wholesalerName }),
        values.contractCode && (React.createElement("div", { className: "w-100" },
            React.createElement("hr", null),
            React.createElement("label", { htmlFor: "includeVoipBundle", className: "checkbox checkbox-square" },
                React.createElement(Field, { id: "includeVoipBundle", name: "includeVoipBundle", type: "checkbox", className: "checkbox checkbox-square " + (errors.includeVoipBundle &&
                        'error'), checked: values.includeVoipBundle, onChange: handleBooleanChange }),
                React.createElement("small", { className: "label voip-label" }, "I would like to add voice to my nbn\u2122 plan")),
            React.createElement("p", { className: "small" },
                "The phone number associated with your commtel Voice service will not be listed in a directory when you sign up. If you wish to make your number available in the public directory, email us at",
                ' ',
                React.createElement("a", { href: "mailto:support@commtel.au" }, "support@commtel.au"),
                "."),
            React.createElement("p", { className: "small" }, "If you have an existing home phone number with a different provider, your number will be disconnected when you transfer your nbn service to us"),
            values.includeVoipBundle && (React.createElement("div", { className: "pl-md-5" },
                React.createElement("a", { href: "//www.commtel.com.au/sites/default/files/2018-02/call-rates-international.pdf", target: "_blank" }, "Detailed call rates"),
                React.createElement("br", null),
                React.createElement("a", { href: planStore.eligibleVoipPlans(values.contractCode)[0]
                        .criticalInformationSummaryUrl, target: "_blank" }, "Critical Information summary"),
                React.createElement("br", null),
                React.createElement("div", { className: "voip-plans" + (errors.voipCode && touched.voipCode ? ' error' : '') },
                    planStore.eligibleVoipPlans(values.contractCode).map(function (plan) { return (React.createElement("label", { htmlFor: plan.code.toString(), className: "checkbox", key: plan.code },
                        React.createElement(Field, { key: plan.code, type: "radio", name: "voipCode", id: plan.code, value: plan.code, checked: values.voipCode === plan.code }),
                        React.createElement("small", { className: "label" },
                            plan.name + ' ',
                            React.createElement("span", { className: "voip-price" },
                                "$",
                                (plan.currentPricing.sellInc / 100).toFixed(2))),
                        React.createElement("p", { className: "voip-description" }, plan.description))); }),
                    React.createElement(Error, { name: "voipCode" })),
                React.createElement(ExistingNumber, { values: values, errors: errors, touched: touched, handleChange: handleValueChange }))))),
        React.createElement("section", { className: "footer-buttons" },
            React.createElement("button", { type: "submit", className: "btn btn-next" }, "Next"))));
});
var ExistingNumber = function (_a) {
    var values = _a.values, errors = _a.errors, touched = _a.touched, handleChange = _a.handleChange;
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "voip-label" }, "Would you like to keep your existing number?"),
        React.createElement("label", { htmlFor: "keepVoipNumber", className: "checkbox" },
            React.createElement(Field, { id: "keepVoipNumber", type: "radio", name: "existingNumber", value: "true", onChange: handleChange, checked: values.existingNumber === true }),
            React.createElement("small", { className: "label" }, "Yes, I would like to keep my existing number")),
        values.existingNumber && (React.createElement("div", { className: "pl-md-5" },
            React.createElement("div", { className: "form-group" },
                React.createElement("label", { htmlFor: "numberToPort" }, "Existing phone number with area code"),
                React.createElement(Field, { id: "numberToPort", name: "numberToPort", component: "input", className: "form-control shadow-alt " + (errors.numberToPort &&
                        touched.numberToPort &&
                        'error'), onChange: handleChange, value: values.numberToPort }),
                React.createElement(Error, { name: "numberToPort" })),
            React.createElement("div", { className: "form-group" },
                React.createElement("label", { htmlFor: "fullName" },
                    "Full name",
                    ' ',
                    React.createElement("small", null, "(as it appears on your current phone provider's account)")),
                React.createElement(Field, { id: "fullName", name: "fullName", component: "input", className: "form-control shadow-alt " + (errors.fullName &&
                        touched.fullName &&
                        'error'), onChange: handleChange, value: values.fullName }),
                React.createElement(Error, { name: "fullName" })),
            React.createElement("div", { className: "form-group" },
                React.createElement("label", { htmlFor: "address" },
                    "Address",
                    ' ',
                    React.createElement("small", null, "(as it appears on your current phone provider's account)")),
                React.createElement(Field, { id: "address", name: "address", component: "input", className: "form-control shadow-alt " + (errors.address &&
                        touched.address &&
                        'error'), onChange: handleChange, value: values.address }),
                React.createElement(Error, { name: "address" })),
            React.createElement("div", { className: "form-group" },
                React.createElement("label", { htmlFor: "accountNumber" }, "Account number with your current phone provider"),
                React.createElement(Field, { id: "accountNumber", name: "accountNumber", component: "input", className: "form-control shadow-alt " + (errors.accountNumber &&
                        touched.accountNumber &&
                        'error'), onChange: handleChange, value: values.accountNumber }),
                React.createElement(Error, { name: "accountNumber" })),
            React.createElement(Waiver, { acceptWaiver: values.voipCsgWaiverAccepted }))),
        React.createElement("label", { htmlFor: "newVoipNumber", className: "checkbox" },
            React.createElement(Field, { id: "newVoipNumber", type: "radio", name: "existingNumber", value: "false", onChange: handleChange, checked: values.existingNumber === false }),
            React.createElement("small", { className: "label" }, "No, I would like a new number")),
        React.createElement(Error, { name: "existingNumber" }),
        !values.existingNumber && (React.createElement("div", { className: "pl-md-5" },
            React.createElement(Waiver, { acceptWaiver: values.voipCsgWaiverAccepted })))));
};
var Waiver = function (_a) {
    var acceptWaiver = _a.acceptWaiver;
    return (React.createElement("div", { className: "waiver" },
        React.createElement("h4", null, "Customer service guarantee waiver"),
        React.createElement("p", null,
            React.createElement("small", null, "The commtel voice service is supplied over the Voice Over Internet Protocol (VOIP). This differs from traditional voice services supplied over copper from other service companies, one of which is the low price.")),
        React.createElement("p", null,
            React.createElement("small", null, "Due to these differences, we require you to waive your rights under the Customer Service Guarantee (known as the \"CSG\").")),
        React.createElement("p", null,
            React.createElement("small", null, "The CSG obliges service providers to meet certain timeframes for service connection, fault rectification and the attendance of appointments. It also requires that written information about the CSG be provided to customers at least once every two years. Compensation is payable for failure to meet these performance standards.")),
        React.createElement("p", null,
            React.createElement("small", null, "Agreeing to this waiver means that you will not be entitled to compensation if we fail to meet the CSG performance standards.")),
        React.createElement("p", null,
            React.createElement("small", null, "You are under no obligation to agree to the waiver and you may withdraw your consent at any time within the 5-working day period from the time you received this email by contacting us. However, if you do not agree to the waiver we are unable to supply you with a voice service.")),
        React.createElement("p", null,
            React.createElement("small", null,
                "If you do not agree to this waiver, please email",
                ' ',
                React.createElement("a", { href: "mailto:support@commtel.au" }, "support@commtel.au"),
                " or call us on 1800 448 305 and mention that you do not wish to agree to this waiver and withdraw the application.")),
        React.createElement("label", { htmlFor: "voipCsgWaiverAccepted", className: "checkbox checkbox-square" },
            React.createElement(Field, { id: "voipCsgWaiverAccepted", name: "voipCsgWaiverAccepted", type: "checkbox", checked: acceptWaiver }),
            React.createElement("small", { className: "label label-waiver" }, "I agree to the above waiver, understand the consequences of consenting to the waiver; and hereby give my consent")),
        React.createElement(Error, { name: "voipCsgWaiverAccepted" })));
};
export var SelectPlanCTL = inject('checkAddressStore', 'appStore', 'summaryStore', 'saleStore', 'planStore', 'config')(withFormik({
    handleSubmit: function (values, bag) {
        bag.props.planStore.setDetailsFromForm(values);
        bag.props.appStore.nextStep();
    },
    mapPropsToValues: function (_a) {
        var planStore = _a.planStore;
        return planStore.planDetails.formValues
            ? planStore.planDetails.formValues
            : planStore.planDetails.formInitialValues;
    },
    validate: function (values) {
        var errors = {};
        var hasSpaces = /^\s.*|.+\s$/;
        var isPhone = /^0(2|3|7|8)[0-9]{8}$/;
        function checkForSpaces(name) {
            if (hasSpaces.test(values[name])) {
                errors[name] = "Start/end of value must not contain spaces";
            }
        }
        if (values['contractCode']) {
            if (values.includeVoipBundle) {
                if (values.voipCode) {
                    if (values.existingNumber) {
                        if (values.numberToPort.match(isPhone) == null) {
                            errors.numberToPort =
                                'Please enter a valid Australian phone number';
                        }
                        if (!values.numberToPort) {
                            errors.numberToPort = 'Please enter your phone number';
                        }
                        else {
                            checkForSpaces('numberToPort');
                        }
                        if (!values.fullName) {
                            errors.fullName = 'Please enter your full name';
                        }
                        else {
                            checkForSpaces('fullName');
                        }
                        if (!values.address) {
                            errors.address = 'Please enter your address';
                        }
                        else {
                            checkForSpaces('address');
                        }
                        if (!/^[0-9]+$/.test(values.accountNumber)) {
                            errors.accountNumber = 'Please enter a valid account number';
                        }
                        if (!values.accountNumber) {
                            errors.accountNumber = 'Please enter your account number';
                        }
                        else {
                            checkForSpaces('accountNumber');
                        }
                    }
                    if (!values.voipCsgWaiverAccepted) {
                        errors.voipCsgWaiverAccepted = 'You must agree to the waiver';
                    }
                }
                else {
                    errors.voipCode = 'You must select a voip package';
                }
            }
        }
        else {
            errors.contractCode = 'Please select a contract';
        }
        return errors;
    },
})(SelectPlanForm));
//# sourceMappingURL=SelectPlanCTL.js.map